export const formatDate = (value: string) => {
  const [day, date, time] = value.split(" ");
  const [hours, minutes] = time.split(":");

  const hour12 = Number(hours) % 12 || 12;
  const ampm = Number(hours) >= 12 ? "PM" : "AM";

  return `${day}, ${date} ${hour12.toString().padStart(2, "0")}:${minutes} ${ampm}`;
};

export const formattedDateMonth = (input: string) => {
  const date = new Date(input);
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
  });
}

export const formatToMMDD = (value?: string) => {
  if (!value) return "-";

  // Expecting YYYY-MM-DD from BE LocalDate
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return "-";

  return `${month}/${day}`;
};
